module.exports = __webpack_public_path__ + "img/checked.36623a32.svg";